import { BrowserUtils } from "../ui-utils/browser-utils";

const getIdleCallback = (): ((cb: () => void) => void) => {
    if (!BrowserUtils.hasWindow()) return (cb) => cb();
    return window.requestIdleCallback
        || window.requestAnimationFrame
        || (window as any).mozRequestAnimationFrame
        || (window as any).webkitRequestAnimationFrame
        || (window as any).msRequestAnimationFrame
        || ((cb) => setTimeout(cb, 0));
}

export function withRequestIdleCallbackAsync<T extends (...args: any[]) => Promise<any>>(
    target: any,
    propertyName: string,
    descriptor: TypedPropertyDescriptor<T>
): TypedPropertyDescriptor<T> | void {
    const originalMethod = descriptor.value;
    if (!originalMethod) return;

    descriptor.value = async function (this: ThisParameterType<T>, ...args: Parameters<T>): Promise<ReturnType<T>> {
        if (!BrowserUtils.hasWindow()) {
            return originalMethod.apply(this, args);
        }
        return new Promise((resolve, reject) => {
            getIdleCallback()(async () => {
                try {
                    resolve(await originalMethod.apply(this, args));
                } catch (e) {
                    reject(e);
                }
            });
        });
    } as T;

    return descriptor;
}

export function withRequestIdleCallback<T extends (...args: any[]) => any>(
    target: any,
    propertyName: string,
    descriptor: TypedPropertyDescriptor<T>
): TypedPropertyDescriptor<T> | void {
    const originalMethod = descriptor.value;
    if (!originalMethod) return;

    descriptor.value = function (this: ThisParameterType<T>, ...args: Parameters<T>): void {
        if (!BrowserUtils.hasWindow()) {
            originalMethod.apply(this, args);
            return;
        }
        getIdleCallback()(() => {
            originalMethod.apply(this, args);
        });
    } as any;

    return descriptor;
}
